import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { PlanningUnitFormInterface } from '@zaoblako/shared/common/dtos/planning-unit/planning-unit-form.dto';
import { TemplateEntityPeriodicityEnum } from '@zaoblako/shared/common/enums/template.entity.periodicity.enum';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';
import { DaysOfWeekSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/days-of-week-single-select/days-of-week-single-select.component';
import { MonthInQuarterSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/month-in-quarter-single-select/month-in-quarter-single-select.component';
import { MonthOfYearSingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/month-of-year-single-select/month-of-year-single-select.component';
import { PeriodicitySingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/periodicity/periodicity-single-select.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import moment from 'moment-timezone';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CardModule } from 'primeng/card';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  standalone: true,
  selector: 'crm-planning-periodicity-card',
  templateUrl: './planning-periodicity-card.component.html',
  imports: [
    CommonModule,
    CardModule,
    PeriodicitySingleSelectComponent,
    JoinPipe,
    DatepickerComponent,
    DaysOfWeekSingleSelectComponent,
    MonthInQuarterSingleSelectComponent,
    MonthOfYearSingleSelectComponent,
    InputNumberModule,
    FormsModule,
    ButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningPeriodicityCardComponent implements OnInit, OnChanges {
  @Input() public planning = <PlanningUnitFormInterface>{};
  @Input() public errors: Record<keyof PlanningUnitFormInterface, any>;

  public timeInternal: Date;

  @Input() public withCard = true;
  @Input() public isShowPeriodicityList = true;
  @Input() public headerName = 'Планирование';
  @Input() public styleClass: string;
  @Input() public appendTo: string;
  @Input() public isShowClearButton = false;
  @Input() public isRequiredField = true;
  @Output() public onClearPlanning = new EventEmitter<any>();
  @Output() public runDateChange = new EventEmitter<Date>();
  @Output() public timeChange = new EventEmitter<string>();

  public readonly workDayOptions = [
    { name: 'Понедельник', value: 1 },
    { name: 'Вторник', value: 2 },
    { name: 'Среда', value: 3 },
    { name: 'Четверг', value: 4 },
    { name: 'Пятница', value: 5 }
  ];

  public get TemplateEntityPeriodicityEnum() {
    return TemplateEntityPeriodicityEnum;
  }

  public ngOnInit(): void {
    if (!this.planning.time) {
      this.planning.time = '00:00';
      this.timeInternal = moment()
        .set({ hour: parseInt(this.planning.time.split(':')[0]), minutes: parseInt(this.planning.time.split(':')[1]) })
        .toDate();
    }
    if (!this.planning.periodicity) {
      this.planning.periodicity = TemplateEntityPeriodicityEnum.NONE;
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.planning?.currentValue && this.planning.time) {
      this.timeInternal = moment()
        .set({ hour: parseInt(this.planning.time.split(':')[0]), minutes: parseInt(this.planning.time.split(':')[1]) })
        .toDate();
    }
  }

  public changeTime() {
    const hour = moment(this.timeInternal)?.hour();
    const minutes = moment(this.timeInternal)?.minutes();
    if (hour === 0 && minutes >= 0 && minutes <= 30) {
      this.timeInternal = moment().startOf('day').set({ minutes: 30 }).toDate();
    }
    this.planning.time = moment(this.timeInternal).format('HH:mm');
    this.timeChange.emit(this.planning.time);
  }
}
